import { Autocomplete, Box, Button, TextField, Typography, Modal, Avatar, Chip, Divider, CircularProgress, InputAdornment } from "@mui/material";
import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import styled from "@emotion/styled";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ContentBox from "../../components/ui/ContentBox";
import { terms_columns } from "../../components/data/termsColumns";
import ButtonSquare from "../../components/ui/ButtonSquare";
import { useNavigate } from "react-router-dom";
import { terms_rows } from "../../components/data/termsRows";
import Api from "../../api/Api";
import { Urls } from "../../api/Urls";
import { useAuthContext } from "../../hooks/useAuthContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import FormikErrorText from "../../components/ui/FormikErrorText";
import BtaDatePicker from "../../components/ui/BtaDatePicker";
import { modalStyle, modalStyleOverflow } from "../../theme/ModalStyle";
import { courts_columns } from "../../components/data/courtsColumns";
import * as Yup from "yup";
import { programs_columns } from "../../components/data/programsColumns";
import Colorful from "@uiw/react-color-colorful";

function Programs() {
  const { user } = useAuthContext();
  const access_token = user?.access_token;
  const [addDurationError, setAddDurationError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [addFrequencyError, setAddFrequencyError] = useState(false);
  const [addProgramError, setAddProgramError] = useState(false);
  const [change, setChange] = useState(false);
  const navigate = useNavigate();
  const [levels, setLevels] = useState([]);
  const [search, setSearch] = useState("");
  const [openEditProgram, setOpenEditProgram] = useState({
    id: null,
    open: false,
  });
  const [openDeleteProgram, setOpenDeleteProgram] = useState({
    id: null,
    open: false,
  });
  const [openAddProgram, setOpenAddProgram] = useState(false);

  const [program, setProgram] = useState({
    name: "",
    max_players: "",
    color_start: "",
    color_end: "",
    levels: [],
    description: "",
    durations: {
      duration: "",
        unit_price: "",
      drop_in_price: "",
    },
  });

  const [data, setData] = useState([]);
  const [programs, setPrograms] = useState([]);
  const perPage = "?perPage=10";
  const [price, setPrice] = useState("");

  const [colorInstanceCreateStart, setColorInstanceCreateStart] = useState("#D0CFCF");
  const [colorInstanceCreateEnd, setColorInstanceCreateEnd] = useState("#D0CFCF");
  const [openStart, setOpenStart] = useState(false);
  const [openEnd, setOpenEnd] = useState(false);
  const [openColorCreateStart, setOpenColorCreateStart] = useState(false);
  const [openColorCreateEnd, setOpenColorCreateEnd] = useState(false);
  const [errorAddedDurations, setErrorAddedDurations] = useState(false);
  const [colorInstanceCreateStartUpdate, setColorInstanceCreateStartUpdate] = useState(program?.color_start);
  const [colorInstanceCreateEndUpdate, setColorInstanceCreateEndUpdate] = useState(program?.color_start);
  const [openStartUpdate, setOpenStartUpdate] = useState(false);
  const [openEndUpdate, setOpenEndUpdate] = useState(false);
  const [openColorCreateStartUpdate, setOpenColorCreateStartUpdate] = useState(false);
  const [openColorCreateEndUpdate, setOpenColorCreateEndUpdate] = useState(false);
  // States for Create Program modal
  const [addedDurationsCreate, setAddedDurationsCreate] = useState([]);
  
  // States for Update Program modal
  const [addedDurationsUpdate, setAddedDurationsUpdate] = useState([]);
  const [deletedDurationsUpdate, setDeletedDurationsUpdate] = useState([]);
  useEffect(() => {
    document.title = "BTA admin - Programs";
  }, []);
  //get list progs
  useEffect(() => {
    console.log(Urls.GET_PROGRAMS, "PROGRAMS");
    Api.get(Urls.GET_PROGRAMS + perPage, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      params: {
        ...(search && { search: search }),
      },
    })
      .then((response) => {
        console.log("programs list:", response.data.data);
        setPrograms(response?.data?.data);
        setData(response?.data);
        if (openEditProgram?.open) {
          handleSelectEdit(response?.data?.data?.filter((program) => program?.id === openEditProgram?.id)[0]);
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        setLoading(false);
      });
  }, [change, search]);

  //handle Pagination
  const handlePagination = (link) => {
    console.log("getting data");
    Api.get(`${link}`, {
      headers: { "Content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        console.log("RESULTAT MATCHED offres DATA", res?.data);
        console.log("RESPONES GHERBI", res);
        setData(res?.data);
        setPrograms(res.data?.data);
        console.log(res?.data?.meta?.links, "link pag");
      })
      .catch((err) => {
        console.log(err);
        setPrograms([]);
      });
  };

  //table style
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "white",
      paddingTop: "8px",
      paddingBottom: "8px",
      letterSpacing: "1px",
      color: `#4B465C`,
      fontSize: 13,
      fontWeight: 500,
    },
    [`&.${tableCellClasses.body}`]: {
      background: "white",
      fontSize: 14,
      color: `#666D83`,
      fontWeight: "500",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
    ":hover": {
      filter: "brightness(0.95)",
    },
    cursor: "pointer",
  }));

  const StyledTable = styled(Table)({
    borderRadius: "0px",
  });
  const initialValuesCreate = {
    name: "",
    max_players: "",
    color_start: "",
    color_end: "",
    levels: [],
    description: "",
    durations: {
      duration: "",
      unit_price: "",
      drop_in_price: "",
    },
  };
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };
  const handleOpenEditProgram = (id) => {
    setOpenEditProgram({
      id: id,
      open: true,
    });
  };
  const handleCloseEditProgram = () => {
    setOpenEditProgram({
      id: null,
      open: false,
    });
    setAddDurationError(false);
    setAddFrequencyError(false);
    setAddProgramError(false);
    setAddedDurationsUpdate([]);
    setDeletedDurationsUpdate([]);
    setProgram({
      name: "",
      max_players: "",
      color_start: "",
      color_end: "",
      levels: [],
      description: "",
    });
  };
  const handleOpenDeleteProgram = (id) => {
    setOpenDeleteProgram({
      id: id,
      open: true,
    });
  };
  const handleCloseDeleteProgram = () => {
    setOpenDeleteProgram({
      id: null,
      open: false,
    });
  };
  const handleOpenCreateProgram = () => {
    // Initialize with one empty duration block
    setAddedDurationsCreate([{
      duration: "",
      unit_price: "",
      drop_in_price: "",
    }]);
    setOpenAddProgram(true);
  };
  const handleCloseCreateProgram = () => {
    setOpenAddProgram(false);
    setAddDurationError(false);
    setAddFrequencyError(false);
    setAddProgramError(false);
    setAddedDurationsCreate([]);
    setProgram({
      name: "",
      max_players: "",
      color_start: "",
      color_end: "",
      levels: [],
      description: "",
    });
    setColorInstanceCreateStart("#D0CFCF");
    setColorInstanceCreateEnd("#D0CFCF");
  };
  const handleCreateProgram = (action) => {
    let error = false;
    if (!program?.name || !program?.max_players || program?.levels?.length === 0 || !program?.color_end || !program?.color_start || !program?.description) {
      setAddProgramError(true);
      error = true;
    } else {
      // Use different duration arrays based on action
      const currentAddedDurations = action === "create" ? addedDurationsCreate : addedDurationsUpdate;
      
      // For both CREATE and UPDATE actions, check if we have at least one valid duration
      if (currentAddedDurations?.length === 0) {
        setAddDurationError(true);
        error = true;
      } else {
        // Validate all durations in the list
        for (let index = 0; index < currentAddedDurations.length; index++) {
          const elementD = currentAddedDurations[index];
          if (!elementD?.duration || !elementD?.unit_price || !elementD?.drop_in_price) {
            setAddDurationError(true);
                error = true;
            break;
              }
            }
          }
        }
    if (error === false && action === "create") {
      setAddDurationError(false);
      setAddFrequencyError(false);
      setErrorAddedDurations(false);
      let levelsIds = [];
      for (let index = 0; index < program?.levels.length; index++) {
        const element = program?.levels[index];
        levelsIds.push(element?.id);
      }
      // Filter out empty durations and convert to proper format
      const durationsToSend = addedDurationsCreate
        .filter(duration => 
          duration?.duration && duration?.unit_price && duration?.drop_in_price
        )
        .map(duration => ({
          duration: parseInt(duration.duration),
          unit_price: parseFloat(duration.unit_price),
          drop_in_price: parseFloat(duration.drop_in_price),
        }));
      console.log("CREATE - All durations:", addedDurationsCreate);
      console.log("CREATE - Filtered durations to send:", durationsToSend);
      setAddProgramError(false);
      Api.post(
        Urls?.ADD_PROGRAM,
        {
          name: program?.name,
          max_players: program?.max_players,
          color_start: program?.color_start.slice(1),
          color_end: program?.color_end.slice(1),
          description: program?.description,
          levels: levelsIds,
          durations: durationsToSend,
        },
        {
          headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
        }
      )
        .then((res) => {
          toast?.success(res?.data?.message);
          setChange(!change);
          handleCloseCreateProgram();
        })
        .catch((err) => {
          toast?.error(err?.response?.data?.message);
        });
    }

    if (error === false && action === "update") {
      setAddDurationError(false);
      setAddFrequencyError(false);
      setAddProgramError(false);
      setErrorAddedDurations(false);

      let levelsIds = [];
      for (let index = 0; index < program?.levels.length; index++) {
        const element = program?.levels[index];
        levelsIds.push(element?.id);
      }
      // Separate new durations from existing ones for UPDATE API
      const validDurations = addedDurationsUpdate.filter(duration => 
        duration?.duration && duration?.unit_price && duration?.drop_in_price
      );
      
      const durationsToUpdate = validDurations
        .filter(duration => duration.id) // Has ID = existing duration
        .map(duration => ({
          id: duration.id,
          duration: parseInt(duration.duration),
          unit_price: parseFloat(duration.unit_price),
          drop_in_price: parseFloat(duration.drop_in_price),
        }));
        
      const durationsToAdd = validDurations
        .filter(duration => !duration.id) // No ID = new duration
        .map(duration => ({
          duration: parseInt(duration.duration),
          unit_price: parseFloat(duration.unit_price),
          drop_in_price: parseFloat(duration.drop_in_price),
        }));
      
      console.log("UPDATE - All durations:", addedDurationsUpdate);
      console.log("UPDATE - Durations to update:", durationsToUpdate);
      console.log("UPDATE - Durations to add:", durationsToAdd);
      console.log("UPDATE - Durations to delete:", deletedDurationsUpdate);
      
      const updateData = {
        name: program?.name,
        max_players: program?.max_players,
        color_start: program?.color_start.slice(1),
        color_end: program?.color_end.slice(1),
        description: program?.description,
        levels: levelsIds,
      };
      
      // Add duration fields only if there are durations to update/add/delete
      if (durationsToUpdate.length > 0) {
        updateData.durations_to_update = durationsToUpdate;
      }
      if (durationsToAdd.length > 0) {
        updateData.durations_to_add = durationsToAdd;
      }
      if (deletedDurationsUpdate.length > 0) {
        updateData.durations_to_delete = deletedDurationsUpdate;
      }
        
      Api.patch(
        Urls?.UPDATE_PROGRAM + openEditProgram?.id,
        updateData,
        {
          headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
        }
      )
        .then((res) => {
          toast?.success(res?.data?.message);
          setChange(!change);
          setDeletedDurationsUpdate([]); // Reset deleted durations after successful update
          handleCloseEditProgram();
        })
        .catch((err) => {
          toast?.error(err?.response?.data?.message);
        });
    }
  };
  const handleDeleteProgram = () => {
    Api?.delete(Urls?.DELETE_PROGRAM + openDeleteProgram?.id, {
      headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        toast?.success(res?.data?.message);
        setChange(!change);
        handleCloseDeleteProgram();
      })
      .catch((err) => {
        toast?.error(err?.response?.data?.message);
      });
  };
  const handleSelectEdit = (program) => {
    setProgram({
      name: program?.name,
      max_players: program?.max_players,
      color_start: "#" + program?.color_start,
      color_end: "#" + program?.color_end,
      levels: program?.levels,
      description: program?.description,
    });
    
    // Convert existing program durations to the simple format
    let durationsArray = [];
    for (let index = 0; index < program?.program_durations?.length; index++) {
      const element = program?.program_durations[index];
      durationsArray.push({
        id: element?.id,
        duration: element?.duration,
        unit_price: element?.unit_price,
        drop_in_price: element?.drop_in_price,
      });
    }
    
    // Always have at least one duration block (empty if no existing durations)
    if (durationsArray.length === 0) {
      durationsArray = [{
        duration: "",
        unit_price: "",
        drop_in_price: "",
      }];
    }
    
    setAddedDurationsUpdate(durationsArray);
    setColorInstanceCreateStartUpdate("#" + program?.color_start);
    setColorInstanceCreateEndUpdate("#" + program?.color_end);
  };
  const handleSaveFrequency = (frequency) => {
    Api.patch(
      Urls?.UPDATE_PROGRAM + openEditProgram?.id,
      {
        frequencies_to_update: [
          {
            id: frequency?.id,
            frequency_per_week: frequency?.frequency_per_week,
            price: parseFloat(frequency?.price),
          },
        ],
      },
      {
        headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
      }
    )
      .then((res) => {
        toast?.success(res?.data?.message);
        setChange(!change);
      })
      .catch((err) => {
        toast?.error(err?.response?.data?.message);
      });
  };
  const handleSaveDurations = (duration) => {
    Api.patch(
      Urls?.UPDATE_PROGRAM + openEditProgram?.id,
      {
        durations_to_update: [
          {
            id: duration?.id,
            duration: duration?.duration,
            unit_price: parseFloat(duration?.unit_price),
            drop_in_price: parseFloat(duration?.drop_in_price),
          },
        ],
      },
      {
        headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
      }
    )
      .then((res) => {
        toast?.success(res?.data?.message);
        setChange(!change);
      })
      .catch((err) => {
        toast?.error(err?.response?.data?.message);
      });
  };
  const handleAddDurations = (duration) => {
    Api.patch(
      Urls?.UPDATE_PROGRAM + openEditProgram?.id,
      {
        durations_to_add: [duration],
      },
      {
        headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
      }
    )
      .then((res) => {
        toast?.success(res?.data?.message);
        setProgram({
          ...program,
          durations: {
            duration: "",
            unit_price: "",
            drop_in_price: "",
          },
        });
        setChange(!change);
      })
      .catch((err) => {
        toast?.error(err?.response?.data?.message);
      });
  };
  const handleAddFrequencies = (frequency, id) => {
    Api.patch(
      Urls?.UPDATE_PROGRAM + openEditProgram?.id,
      {
        frequencies_to_add: [
          {
            program_duration_id: id,
            frequency_per_week: frequency?.frequency_per_week,
            price: parseInt(frequency?.price),
          },
        ],
      },
      {
        headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
      }
    )
      .then((res) => {
        toast?.success(res?.data?.message);
        setChange(!change);
      })
      .catch((err) => {
        toast?.error(err?.response?.data?.message);
      });
  };
  const handleDeleteFrequencies = (frequency) => {
    Api.patch(
      Urls?.UPDATE_PROGRAM + openEditProgram?.id,
      {
        frequencies_to_delete: [frequency?.id],
      },
      {
        headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      }
    )
      .then((res) => {
        toast?.success(res?.data?.message);
        setChange(!change);
      })
      .catch((err) => {
        toast?.error(err?.response?.data?.message);
      });
  };
  const handleDeleteDuration = (duration) => {
    Api.patch(
      Urls?.UPDATE_PROGRAM + openEditProgram?.id,
      {
        durations_to_delete: [duration?.id],
      },
      {
        headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      }
    )
      .then((res) => {
        toast?.success(res?.data?.message);
        setChange(!change);
      })
      .catch((err) => {
        toast?.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    Api.get(Urls?.GET_LEVELS, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        setLevels(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  }, []);
  return (
    <Box display="flex" flexDirection="column" gap="26px" marginTop="26px">
      <ToastContainer />
      <Box>
        <Typography fontSize="22px" fontWeight="500" lineHeight="30px" color="#4B465C">
          Programs
        </Typography>
      </Box>
      {loading && (
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}
      {!loading && (
        <ContentBox>
          <Box display="flex" flexDirection="column" gap="16px">
            <Box>
              <Typography fontSize="18px" fontWeight="500" lineHeight="24px" color="#4B465C">
                List of programs
              </Typography>
            </Box>
            <Box marginTop="8px" flexWrap="wrap" display="flex" gap="16px" flexDirection="row" justifyContent="space-between">
              <Box>
                <Button onClick={handleOpenCreateProgram} sx={{ height: "38px" }} variant="primary_active">
                  Create program
                </Button>
              </Box>
              <TextField value={search} onChange={handleSearchChange} type="input" placeholder="Search program" />
            </Box>
            <TableContainer sx={{ borderRadius: "0px", border: `1px solid #DBDADE` }}>
              <StyledTable aria-label="customized table">
                <TableHead>
                  <TableRow>
                    {programs_columns.map((col, index) => (
                      <StyledTableCell key={index} width={col.width} align={col.align}>
                        {col.name}
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {programs?.map((program) => (
                    <StyledTableRow key={program?.id}>
                      <StyledTableCell align="left">
                        <Typography fontWeight="400" color="#3890E2" fontSize="15px">
                          #{program?.id}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Box display="flex" alignItems="center" gap="10px">
                          <Box height="46px" width="46px" borderRadius="6px" sx={{ background: `linear-gradient(to right, #${program?.color_start}, #${program?.color_end})` }}></Box>
                          <Typography fontSize="15px" lineHeight="22px" fontWeight="600" color="#4B465C">
                            {program?.name}
                          </Typography>
                        </Box>
                      </StyledTableCell>
                      <StyledTableCell align="center">{program?.max_players}</StyledTableCell>

                      <StyledTableCell align="left">
                        <Box display="flex" flexWrap="wrap" gap="10px">
                          {program?.levels?.map((level) => (
                            <Chip variant="primary" label={level?.name} key={level?.id} />
                          ))}
                        </Box>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Box justifyContent="left" display="flex" gap="16px">
                          <ButtonSquare
                            action="edit_outlined"
                            onClick={() => {
                              handleOpenEditProgram(program?.id);
                              handleSelectEdit(program);
                            }}
                          />

                            <ButtonSquare
                              action="delete_red"
                              onClick={() => {
                                handleOpenDeleteProgram(program?.id);
                              }}
                            />
                         {/* {program?.id > 9 && (
                          )}*/}
                        </Box>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </StyledTable>
            </TableContainer>

            {programs?.length === 0 && !loading && <Typography textAlign="center">No programs</Typography>}
            {programs?.length > 0 && (
              <Box justifyContent="flex-end" display="flex" gap="4px">
                {data?.links?.prev && (
                  <ButtonSquare
                    onClick={() => {
                      handlePagination(data?.links?.prev);
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                    action="Previous"
                  />
                )}
                <Box display="flex" gap="4px" justifyContent="center">
                                  {data?.meta?.links?.map((link, index) => (
                  <ButtonSquare
                    key={`pagination-${index}-${link.label}`}
                    onClick={() => {
                      handlePagination(link.url);
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                    action={link?.active ? "number-active" : "number"}
                    number={link.label}
                  />
                ))}
                </Box>
                {data?.links?.next && (
                  <ButtonSquare
                    onClick={() => {
                      handlePagination(data?.links?.next);
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                    action="Next"
                  />
                )}
              </Box>
            )}
          </Box>
        </ContentBox>
      )}
      {/*modals */}
      <Modal open={openAddProgram} onClose={handleCloseCreateProgram}>
        <Box sx={modalStyleOverflow}>
          {/* <pre>{JSON.stringify(program, null, 2)}</pre> */}
          <Box position="absolute" top="2px" right="2px">
            <ButtonSquare action="close" onClick={handleCloseCreateProgram} />
          </Box>
          <Box marginBottom="26px">
            <Typography fontSize="26px" lineHeight="36px" fontWeight="500" color="#4B465C">
              Create Program
            </Typography>
          </Box>

          <Box display="flex" flexDirection="column" gap="16px">
            <Box>
              <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                Program name
              </Typography>
              <TextField onChange={(e) => setProgram({ ...program, name: e.target.value })} value={program?.name} style={{ width: "100%" }} name="name" type="input" id="name" autoComplete="off" placeholder="program 1" />
              <FormikErrorText>{!program?.name && addProgramError && "This field is mandatory"}</FormikErrorText>
            </Box>
            <Box>
              <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                Max number of booking players BY SEANCE
              </Typography>
              <TextField
                inputProps={{
                  min: 0,
                }}
                onChange={(e) => setProgram({ ...program, max_players: e.target.value })}
                value={program?.max_players}
                style={{ width: "100%" }}
                name="max_players"
                type="number"
                id="max_players"
                autoComplete="off"
                placeholder="number of booking players"
              />
              <FormikErrorText>{!program?.max_players && addProgramError && "This field is mandatory"}</FormikErrorText>
            </Box>
            <Box>
              <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                Level
              </Typography>

              <Autocomplete
                sx={{ minWidth: "300px" }}
                options={levels}
                multiple
                isOptionEqualToValue={(option, value) => option?.id === value.id}
                getOptionLabel={(e) => e?.name}
                onChange={(event, value) => {
                  if (value !== null) {
                    setProgram({ ...program, levels: value });
                  } else {
                  }
                }}
                renderInput={(params) => <TextField {...params}
                                                    name="autocomplete" placeholder="Select levels" />}
              />
              <FormikErrorText>{program?.levels?.length === 0 && addProgramError && "This field is mandatory"}</FormikErrorText>
            </Box>
            <Box display="flex" flexDirection="row" gap="16px" flexWrap="wrap">
              <Box>
                <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                  Start color
                </Typography>
                {/* <TextField onChange={(e) => setProgram({ ...program, color_start: e.target.value })} value={program?.color_start} style={{ width: "100%" }} name="color_start" type="input" id="color_start" autoComplete="off" placeholder="ffffff" /> */}
                <Box display="flex" flexDirection="row" gap="10px" sx={{ width: "100%" }}>
                  <Box position="relative" flex={1}>
                    <TextField
                      autoComplete="off"
                      name="color_start"
                      placeholder="#000000"
                      id="color_start"
                      value={colorInstanceCreateStart}
                      fullWidth
                      onChange={(e) => {
                        if (e.target?.value?.length < 8) {
                          setColorInstanceCreateStart(e.target.value);
                          setProgram({ ...program, color_start: e.target.value });
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Box
                              onClick={() => setOpenStart(openStart ? false : true)}
                              sx={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "6px",
                                bgcolor: `${colorInstanceCreateStart}`,
                                cursor: "pointer",
                                "&:hover": {
                                  filter: "brightness(0.8)",
                                },
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box display={openStart ? "flex" : "none"} sx={{ zIndex: "99", position: "absolute", top: "42px", left: "0px" }}>
                      <Colorful
                        disableAlpha
                        color={colorInstanceCreateStart}
                        onChange={(color) => {
                          console.log(color, "color");
                          setColorInstanceCreateStart(color.hex);
                          setProgram({ ...program, color_start: color.hex });
                        }}
                        onMouseLeave={() => setOpenStart(false)}
                      />
                    </Box>
                  </Box>
                </Box>
                <FormikErrorText>{!program?.color_start && addProgramError && "This field is mandatory"}</FormikErrorText>
              </Box>
              <Box>
                <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                  End color
                </Typography>
                {/* <TextField onChange={(e) => setProgram({ ...program, color_end: e.target.value })} value={program?.color_end} style={{ width: "100%" }} name="color_end" type="input" id="color_end" autoComplete="off" placeholder="000000" /> */}
                <Box display="flex" flexDirection="row" gap="10px" sx={{ width: "100%" }}>
                  <Box position="relative" flex={1}>
                    <TextField
                      autoComplete="off"
                      name="color_end"
                      placeholder="#000000"
                      id="color_end"
                      value={colorInstanceCreateEnd}
                      fullWidth
                      onChange={(e) => {
                        if (e.target?.value?.length < 8) {
                          setColorInstanceCreateEnd(e.target.value);
                          setProgram({ ...program, color_end: e.target.value });
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Box
                              onClick={() => setOpenEnd(!openEnd)}
                              sx={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "6px",
                                bgcolor: `${colorInstanceCreateEnd}`,
                                cursor: "pointer",
                                "&:hover": {
                                  filter: "brightness(0.8)",
                                },
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box display={openEnd ? "flex" : "none"} sx={{ zIndex: "99", position: "absolute", top: "42px", left: "0px" }}>
                      <Colorful
                        disableAlpha
                        color={colorInstanceCreateEnd}
                        onChange={(color) => {
                          setColorInstanceCreateEnd(color.hex);
                          setProgram({ ...program, color_end: color.hex });
                        }}
                        onMouseLeave={() => setOpenEnd(false)}
                      />
                    </Box>
                  </Box>
                </Box>
                <FormikErrorText>{!program?.color_end && addProgramError && "This field is mandatory"}</FormikErrorText>
              </Box>
            </Box>
            <Box>
              <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                Description
              </Typography>
              {/* <TextField onChange={(e) => setProgram({ ...program, color_end: e.target.value })} value={program?.color_end} style={{ width: "100%" }} name="color_end" type="input" id="color_end" autoComplete="off" placeholder="000000" /> */}
              <Box display="flex" flexDirection="row" gap="10px" sx={{ width: "100%" }}>
                <Box position="relative" flex={1}>
                  <TextField
                    autoComplete="off"
                    name="desription"
                    multiline
                    rows={3}
                    placeholder="Describe the program"
                    value={program?.description}
                    fullWidth
                    onChange={(e) => {
                      setProgram({ ...program, description: e.target.value });
                    }}
                  />
                </Box>
              </Box>
              <FormikErrorText>{!program?.description && addProgramError && "This field is mandatory"}</FormikErrorText>
            </Box>
            
            {/* Duration blocks for CREATE modal - Simple approach */}
            {addedDurationsCreate?.map((duration, index) => (
              <Box key={index} borderRadius="8px" padding="20px" backgroundColor="#F5F5F5" display="flex" flexDirection="column" gap="16px" marginBottom="2px" sx={{ border: "2px dashed #DBDADE", position: "relative" }}>
                {/* Trash icon only for additional blocks (index > 0) */}
                {index > 0 && (
                  <Box display="flex" justifyContent="flex-end" sx={{ position: "absolute", top: "8px", right: "8px", zIndex: 1 }}>
                    <ButtonSquare action="delete_red" onClick={() => { 
                      const updatedList = addedDurationsCreate.filter((_, i) => i !== index);
                      setAddedDurationsCreate(updatedList);
                    }} />
                  </Box>
                )}
              <Box>
                <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                  Duration
                </Typography>
                <TextField
                  sx={{ maxWidth: "200px", backgroundColor: "white", borderRadius: "6px" }}
                  name="duration"
                  type="number"
                  inputProps={{
                    min: 0,
                  }}
                          value={duration?.duration}
                          onChange={(e) => {
                      const updatedObject = { ...addedDurationsCreate[index], duration: e.target?.value };
                      const updatedList = [...addedDurationsCreate.slice(0, index), updatedObject, ...addedDurationsCreate.slice(index + 1)];
                      setAddedDurationsCreate(updatedList);
                          }}
                          autoComplete="off"
                          placeholder="duration"
                        />
                  <FormikErrorText>{!duration?.duration && addDurationError && "This field is mandatory"}</FormikErrorText>
                  </Box>
                  <Box borderRadius="6px" padding="20px" display="flex" flexDirection="row" gap="40px" backgroundColor="#929292" width="100%" flexWrap="wrap">
                    <Box>
                      <Typography fontSize="13px" fontWeight="400" color="white">
                        Regular unit price
                      </Typography>
                      <TextField
                        sx={{ maxWidth: "200px", backgroundColor: "white", borderRadius: "6px" }}
                        name="regular_unit_price"
                        type="number"
                        inputProps={{
                          min: 0,
                        }}
                        value={duration?.unit_price}
                        onChange={(e) => {
                        const updatedObject = { ...addedDurationsCreate[index], unit_price: e.target?.value };
                        const updatedList = [...addedDurationsCreate.slice(0, index), updatedObject, ...addedDurationsCreate.slice(index + 1)];
                        setAddedDurationsCreate(updatedList);
                        }}
                        autoComplete="off"
                        placeholder="Unit price"
                      />
                    <FormikErrorText>{!duration?.unit_price && addDurationError && "This field is mandatory"}</FormikErrorText>
                    </Box>
                    <Box>
                            <Typography fontSize="13px" fontWeight="400" color="white">
                        Drop-In unit price
                            </Typography>
                            <TextField
                              sx={{ maxWidth: "200px", backgroundColor: "white", borderRadius: "6px" }}
                        name="dropin_unit_price"
                              type="number"
                              inputProps={{
                                min: 0,
                              }}
                        value={duration?.drop_in_price}
                              onChange={(e) => {
                        const updatedObject = { ...addedDurationsCreate[index], drop_in_price: e.target?.value };
                        const updatedList = [...addedDurationsCreate.slice(0, index), updatedObject, ...addedDurationsCreate.slice(index + 1)];
                        setAddedDurationsCreate(updatedList);
                              }}
                              autoComplete="off"
                              placeholder="Unit price"
                            />
                    <FormikErrorText>{!duration?.drop_in_price && addDurationError && "This field is mandatory"}</FormikErrorText>
                    </Box>
                  </Box>
                </Box>
              ))}
              
              {/* Add duration button for CREATE modal */}
              <Box marginTop="2px">
                <Button
                  onClick={() => {
                    // Simply add a new empty duration block
                    setAddedDurationsCreate([...addedDurationsCreate, {
                          duration: "",
                          unit_price: "",
                          drop_in_price: "",
                    }]);
                  }}
                  variant="primary_active"
                >
                  Add duration
                </Button>
              </Box>
          </Box>
          <Box marginTop="26px" display="flex" gap="16px" justifyContent="flex-end">
            <Button onClick={() => handleCreateProgram("create")} variant="primary_active">
              Create
            </Button>
            <Button onClick={handleCloseCreateProgram} variant="primary_inactive">
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={openEditProgram?.open} onClose={handleCloseEditProgram}>
        <Box sx={modalStyleOverflow}>
          <Box position="absolute" top="2px" right="2px">
            <ButtonSquare action="close" onClick={handleCloseEditProgram} />
          </Box>
          <Box marginBottom="26px">
            <Typography fontSize="26px" lineHeight="36px" fontWeight="500" color="#4B465C">
              Update Program
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column" gap="16px">
            <Box>
              <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                Program name
              </Typography>
              <TextField onChange={(e) => setProgram({ ...program, name: e.target.value })} value={program?.name} style={{ width: "100%" }} name="name" type="input" id="name" autoComplete="off" placeholder="program 1" />
              <FormikErrorText>{!program?.name && addProgramError && "This field is mandatory"}</FormikErrorText>
            </Box>
            <Box>
              <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                Max number of booking players BY SEANCE
              </Typography>
              <TextField
                inputProps={{
                  min: 0,
                }}
                onChange={(e) => setProgram({ ...program, max_players: e.target.value })}
                value={program?.max_players}
                style={{ width: "100%" }}
                name="max_players"
                type="number"
                id="max_players"
                autoComplete="off"
                placeholder="number of booking players"
              />
              <FormikErrorText>{!program?.max_players && addProgramError && "This field is mandatory"}</FormikErrorText>
            </Box>
            <Box>
              <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                Level
              </Typography>

              <Autocomplete
                sx={{ minWidth: "300px" }}
                options={levels}
                multiple
                value={program?.levels}
                isOptionEqualToValue={(option, value) => option?.id === value.id}
                getOptionLabel={(e) => e?.name}
                onChange={(event, value) => {
                  if (value !== null) {
                    setProgram({ ...program, levels: value });
                  } else {
                  }
                }}
                renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select levels" />}
              />
              <FormikErrorText>{program?.levels?.length === 0 && addProgramError && "This field is mandatory"}</FormikErrorText>
            </Box>
            <Box display="flex" flexDirection="row" gap="16px" flexWrap="wrap">
              <Box>
                <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                  Start color
                </Typography>
                {/* <TextField onChange={(e) => setProgram({ ...program, color_start: e.target.value })} value={program?.color_start} style={{ width: "100%" }} name="color_start" type="input" id="color_start" autoComplete="off" placeholder="ffffff" /> */}
                <Box display="flex" flexDirection="row" gap="10px" sx={{ width: "100%" }}>
                  <Box position="relative" flex={1}>
                    <TextField
                      autoComplete="off"
                      name="color_start"
                      placeholder="#000000"
                      id="color_start"
                      value={colorInstanceCreateStartUpdate}
                      fullWidth
                      onChange={(e) => {
                        if (e.target?.value?.length < 8) {
                          setColorInstanceCreateStartUpdate(e.target.value);
                          setProgram({ ...program, color_start: e.target.value });
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Box
                              onClick={() => setOpenStartUpdate(!openStartUpdate)}
                              sx={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "6px",
                                bgcolor: `${colorInstanceCreateStartUpdate}`,
                                cursor: "pointer",
                                "&:hover": {
                                  filter: "brightness(0.8)",
                                },
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box display={openStartUpdate ? "flex" : "none"} sx={{ zIndex: "99", position: "absolute", top: "42px", left: "0px" }}>
                      <Colorful
                        disableAlpha
                        color={colorInstanceCreateStartUpdate}
                        onChange={(color) => {
                          setColorInstanceCreateStartUpdate(color.hex);
                          setProgram({ ...program, color_start: color.hex });
                        }}
                        onMouseLeave={() => setOpenStartUpdate(false)}
                      />
                    </Box>
                  </Box>
                </Box>
                <FormikErrorText>{!program?.color_start && addProgramError && "This field is mandatory"}</FormikErrorText>
              </Box>
              <Box>
                <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                  End color
                </Typography>
                {/* <TextField onChange={(e) => setProgram({ ...program, color_end: e.target.value })} value={program?.color_end} style={{ width: "100%" }} name="color_end" type="input" id="color_end" autoComplete="off" placeholder="000000" /> */}
                <Box display="flex" flexDirection="row" gap="10px" sx={{ width: "100%" }}>
                  <Box position="relative" flex={1}>
                    <TextField
                      autoComplete="off"
                      name="color_start"
                      placeholder="#000000"
                      id="color_start"
                      value={colorInstanceCreateEndUpdate}
                      fullWidth
                      onChange={(e) => {
                        if (e.target?.value?.length < 8) {
                          setColorInstanceCreateEndUpdate(e.target.value);
                          setProgram({ ...program, color_end: e.target.value });
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Box
                              onClick={() => setOpenEndUpdate(!openEndUpdate)}
                              sx={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "6px",
                                bgcolor: `${colorInstanceCreateEndUpdate}`,
                                cursor: "pointer",
                                "&:hover": {
                                  filter: "brightness(0.8)",
                                },
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box display={openEndUpdate ? "flex" : "none"} sx={{ zIndex: "99", position: "absolute", top: "42px", left: "0px" }}>
                      <Colorful
                        disableAlpha
                        color={colorInstanceCreateEndUpdate}
                        onChange={(color) => {
                          setColorInstanceCreateEndUpdate(color.hex);
                          setProgram({ ...program, color_end: color.hex });
                        }}
                        onMouseLeave={() => setOpenEndUpdate(false)}
                      />
                    </Box>
                  </Box>
                </Box>
                <FormikErrorText>{!program?.color_end && addProgramError && "This field is mandatory"}</FormikErrorText>
              </Box>
            </Box>
            <Box>
              <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                Description
              </Typography>
              {/* <TextField onChange={(e) => setProgram({ ...program, color_end: e.target.value })} value={program?.color_end} style={{ width: "100%" }} name="color_end" type="input" id="color_end" autoComplete="off" placeholder="000000" /> */}
              <Box display="flex" flexDirection="row" gap="10px" sx={{ width: "100%" }}>
                <Box position="relative" flex={1}>
                  <TextField
                    autoComplete="off"
                    name="desription"
                    multiline
                    rows={3}
                    placeholder="Describe the program"
                    value={program?.description}
                    fullWidth
                    onChange={(e) => {
                      setProgram({ ...program, description: e.target.value });
                    }}
                  />
                </Box>
              </Box>
              <FormikErrorText>{!program?.description && addProgramError && "This field is mandatory"}</FormikErrorText>
            </Box>
            
            {/* Duration blocks for UPDATE modal - Same simple approach as CREATE */}
            {addedDurationsUpdate?.map((duration, index) => (
              <Box key={index} borderRadius="8px" padding="20px" backgroundColor="#F5F5F5" display="flex" flexDirection="column" gap="16px" marginBottom="2px" sx={{ border: "2px dashed #DBDADE", position: "relative" }}>
                {/* Trash icon only for additional blocks (index > 0) or all blocks if there are more than 1 */}
                {(addedDurationsUpdate.length > 1 || index > 0) && (
                  <Box display="flex" justifyContent="flex-end" sx={{ position: "absolute", top: "8px", right: "8px", zIndex: 1 }}>
                    <ButtonSquare action="delete_red" onClick={() => { 
                      const durationToDelete = addedDurationsUpdate[index];
                      
                      // If the duration has an ID, add it to deleted list for API
                      if (durationToDelete.id) {
                        setDeletedDurationsUpdate([...deletedDurationsUpdate, durationToDelete.id]);
                      }
                      
                      // Remove from current list
                      const updatedList = addedDurationsUpdate.filter((_, i) => i !== index);
                      setAddedDurationsUpdate(updatedList);
                    }} />
                  </Box>
                )}
              <Box>
                <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                  Duration
                </Typography>
                <TextField
                  sx={{ maxWidth: "200px", backgroundColor: "white", borderRadius: "6px" }}
                  name="duration"
                  type="number"
                  inputProps={{
                    min: 0,
                  }}
                          value={duration?.duration}
                          onChange={(e) => {
                      const updatedObject = { ...addedDurationsUpdate[index], duration: e.target?.value };
                      const updatedList = [...addedDurationsUpdate.slice(0, index), updatedObject, ...addedDurationsUpdate.slice(index + 1)];
                      setAddedDurationsUpdate(updatedList);
                          }}
                          autoComplete="off"
                          placeholder="duration"
                        />
                  <FormikErrorText>{!duration?.duration && addDurationError && "This field is mandatory"}</FormikErrorText>
                  </Box>
                  <Box borderRadius="6px" padding="20px" display="flex" flexDirection="row" gap="40px" backgroundColor="#929292" width="100%" flexWrap="wrap">
                    <Box>
                      <Typography fontSize="13px" fontWeight="400" color="white">
                        Regular unit price
                      </Typography>
                      <TextField
                        sx={{ maxWidth: "200px", backgroundColor: "white", borderRadius: "6px" }}
                        name="regular_unit_price"
                        type="number"
                        inputProps={{
                          min: 0,
                        }}
                        value={duration?.unit_price}
                        onChange={(e) => {
                        const updatedObject = { ...addedDurationsUpdate[index], unit_price: e.target?.value };
                        const updatedList = [...addedDurationsUpdate.slice(0, index), updatedObject, ...addedDurationsUpdate.slice(index + 1)];
                        setAddedDurationsUpdate(updatedList);
                        }}
                        autoComplete="off"
                        placeholder="Unit price"
                      />
                    <FormikErrorText>{!duration?.unit_price && addDurationError && "This field is mandatory"}</FormikErrorText>
                    </Box>
                    <Box>
                            <Typography fontSize="13px" fontWeight="400" color="white">
                        Drop-In unit price
                            </Typography>
                            <TextField
                              sx={{ maxWidth: "200px", backgroundColor: "white", borderRadius: "6px" }}
                        name="dropin_unit_price"
                              type="number"
                              inputProps={{
                                min: 0,
                              }}
                        value={duration?.drop_in_price}
                              onChange={(e) => {
                        const updatedObject = { ...addedDurationsUpdate[index], drop_in_price: e.target?.value };
                        const updatedList = [...addedDurationsUpdate.slice(0, index), updatedObject, ...addedDurationsUpdate.slice(index + 1)];
                        setAddedDurationsUpdate(updatedList);
                              }}
                              autoComplete="off"
                              placeholder="Unit price"
                            />
                    <FormikErrorText>{!duration?.drop_in_price && addDurationError && "This field is mandatory"}</FormikErrorText>
                    </Box>
                  </Box>
                </Box>
              ))}
              
              {/* Add duration button for UPDATE modal */}
              <Box marginTop="2px">
                <Button
                  onClick={() => {
                    // Simply add a new empty duration block
                    setAddedDurationsUpdate([...addedDurationsUpdate, {
                          duration: "",
                          unit_price: "",
                          drop_in_price: "",
                    }]);
                  }}
                  variant="primary_active"
                >
                  Add duration
                </Button>
              </Box>
          </Box>
          <Box marginTop="26px" display="flex" gap="16px" justifyContent="flex-end">
            <Button onClick={() => handleCreateProgram("update")} variant="primary_active">
              Update
            </Button>
            <Button onClick={handleCloseEditProgram} variant="primary_inactive">
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={openDeleteProgram?.open} onClose={handleCloseDeleteProgram}>
        <Box sx={modalStyleOverflow}>
          <Box position="absolute" top="2px" right="2px">
            <ButtonSquare action="close" onClick={handleCloseDeleteProgram} />
          </Box>
          <Box marginBottom="26px">
            <Typography textAlign="center" fontSize="26px" lineHeight="36px" fontWeight="500" color="#4B465C">
              Delete a program
            </Typography>
          </Box>
          <Box>
            <Typography textAlign="center" fontSize="22px" lineHeight="32px" fontWeight="500" color="#4B465C">
              Are you sure you want to delete this program?
            </Typography>
          </Box>
          <Box marginTop="16px" justifyContent="center" display="flex" gap="16px">
            <Button onClick={handleDeleteProgram} variant="primary_active">
              Delete
            </Button>
            <Button onClick={handleCloseDeleteProgram} variant="primary_inactive">
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default Programs;
